// Module
var code = "<div class=\"container log-detail-container\">\n    <onsite-config log-id=\"selectedLog.id\"></onsite-config>\n</div>";
// Exports
module.exports = code;